import { render, staticRenderFns } from "./EventsCalendar2.vue?vue&type=template&id=74f2683f"
import script from "./EventsCalendar2.vue?vue&type=script&lang=js"
export * from "./EventsCalendar2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports